module.exports = __webpack_public_path__ + "static/KyleHeadshot-30321ca8ce8eb66ce87fcc79a2b262c9.jpg";